@import 'styles/variables';
@import 'styles/mixins';
@import 'styles/blaze/mixins';

.root {
  min-height: 100vh;
  min-height: 100dvh;
  height: 100vh;
  height: 100dvh;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
  width: 100%;
  padding: 48px 20px 72px;
  overflow-y: auto;
}

.withSider {
  padding: 0;
  justify-content: space-between;
  align-items: stretch;
}

.startRoot {
  padding: 0;
}

.compactRoot {
  justify-content: center;
  padding-top: 16px;

  @include for-desktop-only {
    align-items: center;
    padding: 0;
  }

  &.withSider {
    padding-top: 0;
  }
}

.contentShell {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.startContentShell {
  align-items: center;

  @include for-desktop-only {
    flex-direction: row;
  }
}

.blazeIllustration {
  /* stylelint-disable-next-line scss/media-feature-value-dollar-variable */
  @include for-small-desktop-down {
    display: none;
  }

  @include for-small-desktop-up {
    height: calc(100% - 50px);
    margin-right: 22px;
    object-fit: contain;
    aspect-ratio: 1328 / 1446; // Prevent CLS while image loads
    max-width: calc(100% - 450px);
  }
}

.compactLayout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0;
  width: 100%;
  align-self: stretch;
  min-height: 100vh;
  min-height: 100dvh;

  @include for-phone-only {
    flex-direction: column;
    align-items: center;
    gap: 24px;
    padding: 24px;
  }
}

.mainColumn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  max-width: 780px;
  width: 100%;
  min-height: 0;
  padding-top: 16px;
  gap: 16px;

  @include for-desktop-only {
    padding: 0;
    justify-content: center;
  }
}

.startMainColumn {
  flex: 1 1 auto;
  width: 100%;
  max-width: 520px;
  min-height: 100dvh;
  padding-bottom: 0;
  align-self: stretch;
  margin: 0 auto;
  justify-content: flex-start;

  @include for-small-desktop-down {
    padding-top: 72px;
  }
}

.signupCard {
  position: relative;
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
  justify-self: center;
}

.compactCard {
  gap: 16px;
  max-width: 780px;
}

.logo {
  position: absolute;
  top: -72px;
  left: 50%;
  transform: translateX(-50%);

  @include for-phone-only {
    position: static;
    transform: none;
  }
}

.globalLogo {
  margin-top: 32px;
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
}

.subtitle {
  font-family: Sohne;
  font-size: 18px;
  font-weight: 400;
  color: var(--dark-80);
  max-width: 520px;
  line-height: 150%;

  @include for-phone-only {
    font-size: 16px;
  }
}

.startContainer {
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  width: 100%;
  justify-content: center;

  @include for-desktop-only {
    margin-top: 0;
    padding-bottom: 60px;
  }
}

.startContainer .footerText {
  @include for-desktop-only {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin-top: 0;
  }
}

.stageArea {
  width: 100%;
  display: flex;
  justify-content: center;

  .form {
    @include for-desktop-only {
      margin: 0;
    }
  }
}

.stepWrapper {
  width: 100%;
  display: flex;
  justify-content: center;
}

.stepInner {
  position: relative;
  max-width: 780px;
  width: 100%;
}

.stepLogo {
  position: absolute;
  top: -80px;
  left: 50%;
  transform: translateX(-50%);
}

.formCard {
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.stageTitle {
  @include xl-sohne;
  color: var(--dark-80);
  text-align: center;
}

.stageDescription {
  @include md-sohne;
  color: var(--dark-60);
  text-align: center;
}

.formFields {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.centeredCard {
  align-items: flex-start;
  text-align: center;
  margin: 0 auto;
}

.emailForm {
  width: 100%;
}

.emailField {
  position: relative;
}

.codeInputWrapper {
  width: 100%;
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: center;
  box-sizing: border-box;

  @include for-phone-only {
    padding: 0 8px;
  }
}

.codeButtons {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.verifyContainer {
  max-width: 480px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.createAccountForm {
  width: 100%;
  max-width: 520px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

.simpleRequirements {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: center;
  margin-top: 6px;
  color: var(--dark-80);
}

.siderImageContainer {
  position: relative;
  flex-shrink: 0;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
  align-self: stretch;
  justify-self: end;

  @include for-phone-only {
    display: none;
  }
}

.siderImage {
  display: block;
  height: 100vh;
  height: 100dvh;
  width: auto;
}

.error {
  margin-top: 2px;
}

.buttons {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 25px;
  width: 100%;
}

.signupButtons {
  gap: 8px;
  margin-top: 0;

  /* Only OAuth buttons (with icon): icon left, label centered */
  button:has(> svg) {
    justify-content: flex-start;

    > div {
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }
}

.welcomeToBlaze {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .loginLink {
    @include md-sohne;
    color: var(--dark-40);
    text-decoration: underline;
  }
}

.fields {
  @include for-desktop-only {
    gap: 12px !important;
  }
}

.fieldGroup {
  position: relative;
  gap: 4px !important;
}

.showPasswordButton {
  position: absolute;
  right: 8px;
  top: 24px;

  @include for-desktop-only {
    top: 28px;
  }
}

.passwordResetContainer {
  @include for-desktop-only {
    span {
      color: var(--dark-60);
    }
    .resetIt {
      color: var(--dark-60);
      text-decoration: underline;
    }
  }
}

.orSeparator {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  margin: 15px 0;

  .orSeparatorLine {
    width: 82px;
    height: 1px;
    background-color: var(--dark-8);
  }
}

.footerText {
  color: var(--dark-40);
  font-size: 12px;
  margin-top: auto;
  padding: 10px;
  line-height: 130%;
  letter-spacing: 0.48px;

  a {
    color: var(--selected-fill);
    text-decoration: underline;
  }
}

.bold {
  font-weight: 500;
}

.description {
  @include for-desktop-only {
    margin-top: 0;
  }
}

.codeInputContainer {
  align-items: center;
  width: 100%;
  min-width: 0; /* Allow shrinking in flex layouts */

  @include for-desktop-only {
    margin-top: 14px;
    gap: 44px;

    &.hasError {
      gap: 0;
    }
  }
}

.backButton {
  position: absolute;
  top: 13px;
  left: 14px;
  z-index: 1;
}

.signOutButton {
  position: absolute;
  top: 13px;
  right: 14px;
  z-index: 1;
}

.errorText {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinnerContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  width: 100dvw;
  background-color: var(--light-100);
}
